/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { SegmentUsageItem, SEGMENT_USAGE_TYPE, TYPE_DASHBOARD, SegmentUsageIdTypes } from 'cio/utils/segment-usage';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import AuthService from 'cio/services/auth';

const CUTOFF_LIMIT = 5;

interface SegmentUsageCardArgs {
  type: SEGMENT_USAGE_TYPE;
  items: SegmentUsageItem[] | number[];
}

export default class SegmentUsageCard extends Component<SegmentUsageCardArgs> {
  @service auth!: AuthService;

  @tracked _isShowingAll = false;

  get canCreate() {
    switch (this.args.type.id) {
      case SegmentUsageIdTypes.Campaign:
        return this.auth.hasPermission('journeys/campaigns/create');
      case SegmentUsageIdTypes.ApiTriggered:
        return this.auth.hasPermission('journeys/broadcasts/create');
      case SegmentUsageIdTypes.Newsletter:
        return this.auth.hasPermission('journeys/newsletters/create');
      case SegmentUsageIdTypes.SQLImport:
        return this.auth.hasPermission('journeys/imports/create');
      default:
        return false;
    }
  }

  get _visibleItems() {
    return this._isShowingAll ? this.args.items : this.args.items.slice(0, CUTOFF_LIMIT);
  }

  get _hiddenItemsCount() {
    return this.args.items.length - this._visibleItems.length;
  }

  get currentUserIsMonitoringSegment() {
    if (this.args.type.id !== TYPE_DASHBOARD.id || this.auth.user == null) {
      return false;
    }

    // If the type is dashboard, the usage is simply an array of user ids
    return (this.args.items as number[]).includes(Number(this.auth.user.id));
  }
}
